import { ColorMap } from '@/components/fields/PillButtonField/types';
import { NameChoice, Path } from '@/types/global';
import { ProfileStatusLabel } from '@/types/turn-enums';
import { FCRAWorker, ProfileStatus } from '@/types/turn-api';

export const path = (path: Path<FCRAWorker.Details>) => path;

export const GENDER_CHOICES: NameChoice[] = [
  { id: 'M', name: 'Male' },
  { id: 'F', name: 'Female' },
  { id: 'N', name: 'Non-binary' },
];

export const PROFILE_STATUS_VALUE_MAP: Record<ProfileStatus, string> = {
  approved: ProfileStatusLabel.Approved,
  consent: ProfileStatusLabel.Consent,
  emailed: ProfileStatusLabel.Emailed,
  initiated: ProfileStatusLabel.Initiated,
  pending: ProfileStatusLabel.Consider,
  pending__dispute: ProfileStatusLabel.PendingDispute,
  pending__first_notice: ProfileStatusLabel.FirstNotice,
  pending__resolved: ProfileStatusLabel.PendingResolved,
  pending__second_notice: ProfileStatusLabel.SecondNotice,
  processing: ProfileStatusLabel.Processing,
  rejected: ProfileStatusLabel.Rejected,
  review: ProfileStatusLabel.Reviewing,
  review__cm: ProfileStatusLabel.ReviewCm,
  review__identity: ProfileStatusLabel.ReviewIdentity,
  review__mvr: ProfileStatusLabel.ReviewMvr,
  review__qa: ProfileStatusLabel.ReviewQa,
  review__so: ProfileStatusLabel.ReviewSo,
  withdrawn: ProfileStatusLabel.Withdrawn,
};

/** Sorted choices for list filters (API value + display label). */
export const PROFILE_STATUS_FILTER_CHOICES: NameChoice[] = (
  Object.entries(PROFILE_STATUS_VALUE_MAP) as [ProfileStatus, string][]
)
  .map(([id, name]) => ({ id, name }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const MONITORING_STATUS_FILTER_CHOICES: NameChoice[] = [
  { id: 'manual_unenroll', name: 'Manual Unenroll' },
  { id: 'manual_enroll', name: 'Manual Enroll' },
  { id: 'enrolled', name: 'Enrolled' },
  { id: 'error_unenrollment', name: 'Error Unenrollment' },
  { id: 'unenrolled', name: 'Unenrolled' },
];

export const PROFILE_STATUS_COLOR_MAP: ColorMap = {
  approved: 'turn_success',
  consent: 'turn_orange',
  emailed: 'turn_violet',
  initiated: 'turn_violet',
  pending: 'turn_orange',
  pending__dispute: 'turn_orange',
  pending__first_notice: 'turn_error',
  pending__resolved: 'turn_orange',
  pending__second_notice: 'turn_error',
  processing: 'turn_info',
  rejected: 'turn_error',
  review: 'turn_info',
  review__cm: 'turn_info',
  review__identity: 'turn_info',
  review__mvr: 'turn_info',
  review__qa: 'turn_info',
  review__so: 'turn_info',
  withdrawn: 'turn_neutral',
};
